import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Gertrude",
  "description": "",
  "published": "2007-06-14T00:00:00.000Z",
  "redirect_from": ["/blog/gertrude/swizec/188"],
  "categories": "intrigues, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Was playing with Gertrude, my LEGO trebuchet yesterday and decided to make this video of quite crappy quality. Should've blogged it yesterday, but it somehow slipped my mind.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      